import { PropType, computed, defineComponent, ref, watch } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import CountyLayoutResourceDotRender from './countyLayoutResourceDotRender'
import CountyLayoutResourceIconRender from './countyLayoutResourceIconRender'
import CountyLayoutBoundaryRender from './countyLayoutBoundaryRender'
import { MapViewMode, Marker } from '@/pages/chargermap/contract/map'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'county-layout-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    BMapGL: {
      type: Object,
    },
  },

  setup: (props) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const componentStore = computed(() => props.componentStore)
    const BMapGL = computed(() => props.BMapGL)

    const route = useRoute()
    let timer: any = null
    const ready = ref(false)
    const renderStart = computed(
      () => componentStore.value.viewMode === MapViewMode.CountyLayout && ready.value
    )
    watch(
      () => route.name,
      (newVal, oldVal) => {
        if (newVal === 'countyLayout') {
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
            ready.value = true
            // console.log('====================================')
            // console.log('ready.value: ', ready.value)
            // console.log('====================================')
          }, 500)
        }
      },
      { immediate: true }
    )

    return () => (
      <>
        {renderStart.value ? (
          <>
            <CountyLayoutResourceDotRender
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
            ></CountyLayoutResourceDotRender>
            <CountyLayoutResourceIconRender
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
            ></CountyLayoutResourceIconRender>
            <CountyLayoutBoundaryRender
              mapContextRef={mapContextRef.value}
              mapInstance={mapInstance.value}
              componentStore={componentStore.value}
              BMapGL={BMapGL.value}
            ></CountyLayoutBoundaryRender>
          </>
        ) : null}
      </>
    )
  },
})
